var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 503,
    viewBox: "0 0 340 503",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1072_1156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.39 181.24C162.39 178.52 185.9 135.52 169.82 105.43C153.74 75.3399 104.94 70.9699 83.77 97.7199C62.6 124.47 77.22 185.33 128.39 181.24Z",
    fill: "#1480E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.64 8.5C115.47 23.13 175.91 37.95 207.53 82.06C230.76 214.29 218.99 353.59 221.36 488.13C215.81 508.33 175.9 459.02 165.36 454.27C129.03 420.34 78.99 389.94 77.36 335.14C73.08 227.92 73.19 121.56 70.27 14.01C69.57 103.25 69.11 200.31 68.91 300.32C65.48 346.24 77.69 393.32 116.09 422.25C139.16 435.69 212.87 534.59 231.09 491.45C230.41 351.03 237.47 214.27 213.39 82.45C182.4 35.13 116.53 21.8 65.64 8.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56 499.25C240.83 496.43 261.11 502.25 273.86 492.75C278.36 451.97 271.5 409.24 271.64 367.75C263.07 263.22 273.53 152.31 237.36 52.53C213.95 9.78998 155.03 8.83998 112.24 0.769978C101.24 -0.230022 85.24 -2.02002 79.19 9.36998C84.62 -0.0500193 97.72 0.819978 107.27 1.90998C258.71 13.86 245.98 95.73 254.46 220.02C259.92 310.22 265.46 393.77 272.26 479.82C277.42 504.45 239.64 494.13 225.56 499.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.5 487.69C313.08 533.61 297.69 269.51 291.17 248.53C275.01 210 264.43 22.71 232.11 30.2C266.74 37.1 253.17 154.88 272.45 202.07C281.43 228.27 315.64 526.27 270.5 487.69Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.9 360.42C242.26 400.66 244.8 440.15 248.97 479.87C256.48 441.88 256.21 397.3 244.9 360.42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.19 347.55C243.94 252.13 262.73 138.06 209 53.8601C187.24 28.4901 151.88 30.5501 123.19 18.3101C159.25 34.0701 206.32 39.4001 218.26 84.1501C240.47 167.66 239.33 264.87 247.19 347.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.15 105.96C141.02 114.37 207.15 96.4801 201.56 163.49C203.21 181 209.14 242.98 186.56 244.43C67.05 224.13 106.06 217.51 97.76 104.58C98.62 141.68 83.27 197.52 103.65 232.93C153.28 241.33 214.91 287.5 213.14 203.99C215.46 99.9801 186.79 104.29 96.15 105.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.46 0.709961C292.29 0.959961 292.32 15.86 302.46 16.14C312.64 15.89 312.64 0.989961 302.46 0.709961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64001 127.27C-2.52999 127.52 -2.50999 142.42 7.64001 142.7C17.79 142.45 17.76 127.55 7.64001 127.27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.64 401.25C321.48 401.5 321.5 416.4 331.64 416.68C341.83 416.43 341.81 401.53 331.64 401.25Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1072_1156"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 339.28,
    height: 502.25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecond);
export default __webpack_public_path__ + "static/media/second.b6f4c7bf5a46a41eaadb581b1b54db9c.svg";
export { ForwardRef as ReactComponent };